<script>
import { mapState } from "vuex";
import IconHome from "@/assets/img/icon/section/IconHome.vue";
import IconMenuCliente from "@/assets/img/icon/section/IconMenuCliente.vue";

export default {
	components: {
		IconHome,
		IconMenuCliente
	},
	props: {
		toggle: {
			type: Boolean,
			required: true
		},
		logoCliente: {
			type: String,
			required: true
		}

	},
	data() {
		return {
			sidebarMobile: false
		};
	},

	computed: {
		...mapState("MenuModule", ["listMenuIntranet", "menuCliente"]),
	},

	methods: {
		sidebarShow() {
			this.sidebarMobile = !this.sidebarMobile;
		},
		toggleFoldMenuItem(item) {
			item.show = !item.show;
		},
		toggleFoldPrimario(menu) {
			this.menuCliente.forEach((item) => {
				item.principal.forEach((item) => {
					if(menu.show !== item.show) {
						item.show = false;
					}
				});
			});
			menu.show = !menu.show;		
		},
		sidebarCollapse() {
			this.$emit("sidebarCollpase");
		},
		contactoShow() {
			this.$emit('eventContactoShow');
		},
		notificacionesShow() {
			this.$emit('eventNotificacionesShow');
		}
	}
};
</script>

<template>
<aside class="sidebar-custom">
	<a 
		@click="sidebarCollapse()"
		href="javascript:" 
		class="sidebar-custom-btn-collapse">
		<span v-if="toggle" key="arrow-left">
			<font-awesome-icon icon="fa-solid fa-angle-left" ></font-awesome-icon>
		</span>
		<span v-if="!toggle" key="arrow-right">
			<font-awesome-icon icon="fa-solid fa-angle-right" ></font-awesome-icon>
		</span>
	</a>
	<div class="sidebar-custom-logo">
		<router-link to="/inicio" class="sidebar-custom-logo-link ps-3 ps-lg-0">
			<img v-if="logoCliente" :src="logoCliente" class="d-block sidebar-custom-logo-image">
			<img v-else width="45" src="@/assets/img/intranet/nav-vertical/icono-teamworkup.svg" class="d-block" > 
		</router-link>
		<div class="d-flex d-lg-none">
			<a 
				@click="contactoShow()"
				href="javascript:" 
				class="navbar-custom-menu-btn position-relative me-3"
			>
				<font-awesome-icon icon="fa-solid fa-circle-user" class="navbar-custom-menu-btn-icon" ></font-awesome-icon>
				<span class="navbar-custom-menu-btn-circle bg-red border border-light rounded-circle"></span>
			</a>
			<a
			@click="notificacionesShow()"
			href="javascript:" 
			class="navbar-custom-menu-btn position-relative me-3" 
			>
			<font-awesome-icon icon="fa-solid fa-bell" class="navbar-custom-menu-btn-icon" ></font-awesome-icon>
			<span class="navbar-custom-menu-btn-circle bg-red border border-light rounded-circle"></span>
		</a>
		<a 
		@click="sidebarShow()"
		href="javascript:" 
		role="button" 
		class="btn sidebar-custom-btn btn-custom btn-custom-line-gray btn-block d-xl-none color-main me-3">
		<font-awesome-icon icon="fa-solid fa-bars"></font-awesome-icon>
			</a>
		</div>
	</div>
	<ul 
		class="sidebar-custom-menu mb-0"
		:class="sidebarMobile ? 'sidebar-custom-menu-show' : '' "
	>
		<li class="mt-3"></li>		
		<li class="sidebar-custom-menu-item sidebar-custom-menu-item btn-menu-cliente">
			<a 
				@click="sidebarCollapse()"
				href="javascript:"  
				class="sidebar-custom-menu-item-link mx-2 px-3"
			>
				<IconMenuCliente 
					width="20" 
					height="20" 
					class="d-block"
				/>
			</a>
		</li>	
		<li class="sidebar-custom-menu-item sidebar-custom-menu-item-collapse d-xxl-none mt-3">
			<span class="sidebar-custom-menu-item-title mx-2 px-2">
				<IconMenuCliente width="14" height="14" 
					class="me-2"
					style="margin-top: -2px;" 
				/>
				Menú
			</span>
		</li>	
		<li 
			v-for="header in menuCliente" 
			:key="header.id_header + header.nombre_header"
			class="sidebar-custom-menu-item sidebar-custom-menu-item-collapse d-xxl-none"
		>
			<template v-if="header.principal.length == 0">
				<a 
					href="javascript:"
					:style="{ 'color': header.color_activo }"
					class="sidebar-custom-menu-item-link mx-2 px-3"
				>
					<span class="sidebar-custom-menu-item-link-text">
						{{ header.nombre_header }}  
					</span>
				</a>			
			</template>

			<template v-else>
				<a 
					href="javascript:" 
					@click="toggleFoldMenuItem(header)" 
					:style="{ 'color': header.color_activo }"
					class="sidebar-custom-menu-item-link mx-2 px-3"
					:class="header.show ? 'active' : '' "
				>
					<span class="d-flex">
						<span class="sidebar-custom-menu-item-link-text">						
							{{ header.nombre_header }}
						</span>
					</span>
					<span v-if="header.show" class="d-flex d-md-none d-xl-flex">
						<font-awesome-icon icon="fa-solid fa-angle-up" class="ps-3" ></font-awesome-icon>
					</span>
					<span v-else class="d-flex d-xl-flex">
						<font-awesome-icon icon="fa-solid fa-angle-down" class="ps-3" ></font-awesome-icon>
					</span>
				</a>
			</template>

			<ul 
				class="sidebar-custom-menu-primer-nivel mr-xl-4"
				:class="{ 'sidebar-custom-menu-primer-nivel-show': header.show }"
			>
				<li 
					v-for="principalEl in header.principal" 
					:key="principalEl.id_elemento + principalEl.nombre_elemento"
					class="sidebar-custom-menu-primer-nivel-item">
					<template v-if="principalEl.secundarios.length == 0">
						<template v-if="principalEl.url_externa">							
							<a 
								:href="principalEl.url_externa" 
								class="sidebar-custom-menu-primer-nivel-item-link mx-2 px-2">
								<span class="sidebar-custom-menu-item-link-text">
									{{ principalEl.nombre_elemento }}
								</span>
							</a>
						</template>
						<template v-else>					
							<a 
								href="javascript:"
								class="sidebar-custom-menu-primer-nivel-item-link mx-2 px-2">
								<span class="sidebar-custom-menu-item-link-text">
									{{ principalEl.nombre_elemento }}
								</span>
							</a>
						</template>
					</template>
					<template v-else>							
						<a 
							href="javascript:" 
							@click="toggleFoldMenuItem(principalEl)" 
							class="sidebar-custom-menu-primer-nivel-item-link mx-2 px-3"
							:class="{ 'active': principalEl.show }"
						>
							<span class="sidebar-custom-menu-item-link-text">
								{{ principalEl.nombre_elemento }}   
							</span>
							<span v-if="principalEl.show">
								<font-awesome-icon icon="fa-solid fa-angle-up" class="ps-3" ></font-awesome-icon>
							</span>
							<span v-else>
								<font-awesome-icon icon="fa-solid fa-angle-down" class="ps-3" ></font-awesome-icon>
							</span>
						</a>
					</template>

					<ul 
						class="sidebar-custom-menu-segundo-nivel mr-xl-4"
						:class="{ 'sidebar-custom-menu-segundo-nivel-show': principalEl.show }" 
					>
						<li 
							v-for="secundarioEl in principalEl.secundarios" 
							:key="secundarioEl.id_elemento + secundarioEl.nombre_elemento"
							class="sidebar-custom-menu-segundo-nivel-item">

							<template v-if="secundarioEl.terciarios.length == 0">
								<template v-if="secundarioEl.url_externa">								
									<a 
										:href="secundarioEl.url_externa"
										class="sidebar-custom-menu-segundo-nivel-item-link mx-2 px-2">
										<span class="sidebar-custom-menu-item-link-text ps-2">
											{{ secundarioEl.nombre_elemento }}    
										</span>
									</a>
								</template>
								<template v-else>								
									<a 
										href="javascript:"
										class="sidebar-custom-menu-segundo-nivel-item-link mx-2 px-2">
										<span class="sidebar-custom-menu-item-link-text ps-2">
											{{ secundarioEl.nombre_elemento }}    
										</span>
									</a>
								</template>							
							</template>
							<template v-else>
								<a 
									href="javascript:" 
									@click="toggleFoldMenuItem(secundarioEl)" 
									class="sidebar-custom-menu-segundo-nivel-item-link mx-2 px-3"
									:class="secundarioEl.show ? 'active' : '' "
								>
									<span class="sidebar-custom-menu-item-link-text">
										{{ secundarioEl.nombre_elemento }}   
									</span>
									<span v-if="secundarioEl.show">
										<font-awesome-icon icon="fa-solid fa-angle-up" class="ps-3" ></font-awesome-icon>
									</span>
									<span v-else>
										<font-awesome-icon icon="fa-solid fa-angle-down" class="ps-3" ></font-awesome-icon>
									</span>
								</a>		
							</template>

							<ul
								class="sidebar-custom-menu-tercer-nivel mr-xl-4"
								:class="{ 'sidebar-custom-menu-tercer-nivel-show': secundarioEl.show }" 
							>
								<li 
									v-for="terciarioEl in secundarioEl.terciarios" 
									:key="terciarioEl.id_elemento + terciarioEl.nombre_elemento"
									class="sidebar-custom-menu-tercer-nivel-item"
								>
									<a 
										:href="terciarioEl.url_externa"
										class="sidebar-custom-menu-tercer-nivel-item-link mx-2 px-2"
									>
										<span class="sidebar-custom-menu-item-link-text ps-2">
											{{ terciarioEl.nombre_elemento }}    
										</span>
									</a>
								</li>
							</ul>

						</li>
					</ul>
				</li>
			</ul>
		</li>

		<li class="sidebar-custom-menu-item">
			<router-link
				to="/inicio"
				class="sidebar-custom-menu-item-link mx-2 px-3"
			> 
				<IconHome width="20" height="20" style="margin-top: -2px;" />
				<span class="sidebar-custom-menu-item-link-text ps-2">
					Inicio
				</span>
			</router-link>
		</li>

		<li class="pb-3 mb-3 border-bottom d-xxl-none"></li>
		<li class="sidebar-custom-menu-item mt-3">
			<small class="sidebar-custom-menu-item-link-text color-gray mx-2 mx-md-2 px-3 px-md-2 mx-xl-3">
				MÓDULOS
			</small>
		</li>
		<li 
			v-for="(menu, i) in listMenuIntranet"
			:key="i"
			class="sidebar-custom-menu-item"
		>
			<router-link
				:to="menu.ruta"
				class="sidebar-custom-menu-item-link mx-2 px-3"
			> 
				<span class="sidebar-custom-menu-item-link-icon sidebar-custom-menu-item-link-svg" 
					:style="`-webkit-mask: url(${menu.url_menu_activo}); mask: url(${menu.url_menu_activo}); mask-repeat: no-repeat;`">
				</span>
				<span class="sidebar-custom-menu-item-link-text ps-2">
					{{ menu.nombre_modulo }}
				</span>
			</router-link>
		</li>
		<li class="pb-3"></li>
	</ul>
</aside>
</template>